import FeaturesSection from "@components/Pages/Studio/OverviewPage/FeaturesSection/FeaturesSection"
import OverviewFAQSection from "@components/Pages/Studio/OverviewPage/OverviewFAQSection/OverviewFAQSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import ProductHero from "@components/WebsiteRevamp/Heros/ProductHero/ProductHero"
import PageSubNavigation from "@components/WebsiteRevamp/PageSubNavigation/PageSubNavigation"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import CustomerStories from "@jsons/customerStories.json"
import StudioOverview from "@jsons/studioOverview.json"
import BenefitsSection from "@pages/Studio/OverviewPage/BenefitsSection/BenefitsSection"
import CustomersSection from "@pages/Studio/OverviewPage/CustomersSection/CustomersSection"
import DevicesSection from "@pages/Studio/OverviewPage/DevicesSection/DevicesSection"
import FormSection from "@pages/Studio/OverviewPage/FormSection/FormSection"
import IntroductionSection from "@pages/Studio/OverviewPage/IntroductionSection/IntroductionSection"
import SolutionSection from "@pages/Studio/OverviewPage/SolutionSection/SolutionSection"
import React from "react"

type Props = {}

const overview = (props: Props) => {
	const list = getTranslatedPageData(StudioOverview, true, true)

	const mainContent = getValueOrThrow(list.AdvancedSideAsset)

	const stories = getPosts("CustomerStoriesModule", {data: CustomerStories})

	return (
		<>
			<HeadMeta
				meta={list.metaData}
				customPath="/products/studio/overview"
			/>

			<section>
				<ProductHero
					theme={"studio"}
					data={getValueOrThrow(list.heroData?.[0])}
				/>
			</section>

			{list.subMenu && (
				<PageSubNavigation withCurve data={list.subMenu} />
			)}
			<IntroductionSection data={mainContent[0]} />

			<BenefitsSection data={mainContent[1]} />

			<SolutionSection data={mainContent[2]} />

			<DevicesSection data={mainContent[3]} />

			<FeaturesSection data={mainContent[4]} />

			<CustomersSection data={stories} />

			<OverviewFAQSection faq={getValueOrThrow(list.faqData)} />

			<FormSection />
		</>
	)
}

export default overview
